import Phaser from 'phaser';
// import config from '../config';

class Joystick extends Phaser.GameObjects.Ellipse {
    constructor(scene, diameter, ringDiameter, defaultPosition) {
        super(scene, 0, 0, diameter, diameter, 0xDFDFDF);

        scene.add.existing(this);

        this.ring = scene.ring;
        const ringScale = ringDiameter / this.ring.width;
        this.ring.setScale(ringScale, ringScale);
        this.radius = ringDiameter / 2;
        this.defaultPosition = defaultPosition;

        this.ring.setAlpha(0);
        this.setAlpha(0);
    }

    getDefaultCoord() {
        const {
            x, y, offsetX, offsetY,
        } = this.defaultPosition;

        return { x: offsetX + x + this.radius, y: offsetY + y + this.radius };
    }

    getDefaultPosition() {
        if (this.defaultPosition !== null) {
            const { x, y } = this.getDefaultCoord();

            this.setPosition(x, y + 15);
            this.ring.setPosition(x, y + 15);

            this.scene.tweens.add({
                targets: this,
                y,
                alpha: 1,
                ease: 'Cubic',
                duration: 1000,
            });

            this.scene.tweens.add({
                targets: this.ring,
                y,
                alpha: 1,
                ease: 'Cubic',
                duration: 1000,
            });
        }
    }

    changeVisibility(isShow = false, x, y) {
        if (isShow) {
            this.startPosition = { x, y };
            this.ring.setAlpha(0);
            this.setAlpha(0);
            this.setPosition(x, y);
            this.ring.setPosition(x, y);
        }

        this.scene.tweens.add({
            targets: this,
            alpha: isShow ? 1 : 0,
            ease: 'Cubic',
            duration: 1000,
        });

        this.scene.tweens.add({
            targets: this.ring,
            alpha: isShow ? 1 : 0,
            ease: 'Cubic',
            duration: 1000,
        });
    }

    changeJoystickPosition(x, y) {
        if (this.startPosition) {
            const currentRadius = Math.sqrt(
                (x - this.startPosition.x) ** 2 + (y - this.startPosition.y) ** 2,
            );
            this.scene.tweens.add({
                targets: this,
                x: currentRadius < this.radius
                    ? x : this.startPosition.x
                        + (this.radius / currentRadius) * (x - this.startPosition.x),
                y: currentRadius < this.radius
                    ? y : this.startPosition.y
                        + (this.radius / currentRadius) * (y - this.startPosition.y),
                ease: 'Linear',
                duration: 100,
            });
        }
    }
}

export default Joystick;
